import React from 'react';
import { isFormFilled } from '../utils/visaApplicationData';

const canEditForm = (app) => {
  const status = String(app?.application_status || '').toLowerCase();
  return status !== 'finalize';
};

const VisaApplicationTableActions = ({
  app,
  onView,
  onViewHistory,
  onUpdateStatus,
  onEditForm,
  canUpdateStatus,
  allowEditForm,
}) => {
  const filled = app.form_filled ?? isFormFilled(app.customer_visa_application_data);
  const editAllowed = allowEditForm === undefined ? true : Boolean(allowEditForm);
  const showEdit = onEditForm && canEditForm(app) && editAllowed;

  return (
    <div className="flex gap-2 flex-wrap">
      {showEdit && (
        <button
          type="button"
          onClick={() => onEditForm(app)}
          className="text-sm px-3 py-1.5 rounded-lg font-medium bg-amber-50 text-amber-700 hover:bg-amber-100 transition-colors"
        >
          {filled ? 'Update Form' : 'Fill Form'}
        </button>
      )}
      {filled && onView && (
        <button
          type="button"
          onClick={() => onView(app)}
          className="text-sm px-3 py-1.5 rounded-lg font-medium bg-blue-50 text-blue-600 hover:bg-blue-100 transition-colors"
        >
          View
        </button>
      )}
      {onViewHistory && (
        <button
          type="button"
          onClick={() => onViewHistory(app)}
          className="text-sm px-3 py-1.5 rounded-lg font-medium bg-purple-50 text-purple-600 hover:bg-purple-100 transition-colors"
        >
          History
        </button>
      )}
      {canUpdateStatus && onUpdateStatus && (
        <button
          type="button"
          onClick={() => onUpdateStatus(app)}
          className="text-sm px-3 py-1.5 rounded-lg font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
        >
          Update Status
        </button>
      )}
    </div>
  );
};

export default VisaApplicationTableActions;
